import { Box, Typography } from '@mui/material';
import Manual1 from 'assets/Manual1.webp';
import Manual2 from 'assets/Manual2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function ManualDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Manual" Chunk method description:</Typography>
      <Typography marginTop={2}>Supported file formats are {allowedFilesMap.naive.join(', ')}.</Typography>
      <ul>
        <li>
          We assume that the manual has a hierarchical section structure, using the lowest section titles as basic unit
          for chunking documents. Therefore, figures and tables in the same section will not be separated, which may
          result in larger chunk sizes.
        </li>
      </ul>
      <Typography fontWeight='500'>"Manual" Examples</Typography>
      <Typography marginBottom={3}>The following screenshots are provided for clarity.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={Manual1} alt='Manual1' width={320} />
        <img src={Manual2} alt='Manual2' width={320} />
      </Box>
    </Box>
  );
}
